/** App language options — order matches language selection UI; first is default. */
export const DEFAULT_LANG = 'de'

export const LANG_OPTIONS = [
  { name: 'Deutsch', value: 'de', flag: '/img/de_de.png' },
  { name: 'français', value: 'fr', flag: '/img/fr_fr.svg' },
  { name: 'English', value: 'en', flag: '/img/en_us.png' },
  { name: 'Italiano', value: 'it', flag: '/img/it_it.svg' },
  { name: '简体中文', value: 'zh', flag: '/img/zh_cn.png' },
]

export const ALLOWED_LANGS = LANG_OPTIONS.map((o) => o.value)

export function normalizeLang(lang) {
  if (ALLOWED_LANGS.includes(lang)) return lang
  return DEFAULT_LANG
}

export function getStoredLang() {
  return normalizeLang(localStorage.getItem('lang'))
}

/**
 * Multi-lang fields stored as zh|en|ja|kr.
 * de/fr/it fall back to English segment.
 */
export function pickPipeText(text, lang) {
  if (!text || String(text).indexOf('|') === -1) return text || ''
  const parts = String(text).split('|')
  const l = normalizeLang(lang)
  const indexMap = { zh: 0, en: 1, ja: 2, kr: 3, de: 1, fr: 1, it: 1 }
  const idx = indexMap[l] != null ? indexMap[l] : 1
  return parts[idx] || parts[1] || parts[0] || ''
}

/** Comma-separated class names: kr,en,ja,zh historically — map new langs to en. */
export function pickCommaText(text, lang) {
  if (!text || String(text).indexOf(',') === -1) return text || ''
  const parts = String(text).split(',')
  const l = normalizeLang(lang)
  if (l === 'zh') return parts[0] || parts[3] || ''
  if (l === 'en' || l === 'de' || l === 'fr' || l === 'it') return parts[1] || parts[0] || ''
  if (l === 'ja') return parts[2] || parts[1] || parts[0] || ''
  return parts[3] || parts[0] || ''
}
